import { render, staticRenderFns } from "./UserAccessObjects.vue?vue&type=template&id=51e4635e&lang=pug"
import script from "./UserAccessObjects.vue?vue&type=script&lang=js"
export * from "./UserAccessObjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51e4635e')) {
      api.createRecord('51e4635e', component.options)
    } else {
      api.reload('51e4635e', component.options)
    }
    module.hot.accept("./UserAccessObjects.vue?vue&type=template&id=51e4635e&lang=pug", function () {
      api.rerender('51e4635e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/powerbi/components/UserAccessObjects.vue"
export default component.exports